import { PrismicRichText } from '@prismicio/react'
import { StyledP } from 'components/common/typography'
import { MainContainer } from './richText_styles'

const RichText = props =>
  <MainContainer {...props}>
    <PrismicRichText
      field={props?.data?.richText}
      components={{
        paragraph: ({ children, node }) => (node.text.length === 0 ? <br /> : <p>{children}</p>),
        heading1: ({ children }) => <StyledP variant='h1'>{children}</StyledP>,
        heading2: ({ children }) => <StyledP variant='h2'>{children}</StyledP>,
        heading3: ({ children }) => <StyledP variant='h3'>{children}</StyledP>,
        heading4: ({ children }) => <StyledP variant='h4'>{children}</StyledP>,
        heading5: ({ children }) => <StyledP variant='h5'>{children}</StyledP>
      }}
    />
  </MainContainer>

export default RichText
